<template>
  <div>
    <b-aspect aspect="16:9">
      <StreamBarcodeReader
        @decode="onDecode"
        @loaded="onLoaded"
      ></StreamBarcodeReader>
    </b-aspect>

    <b-navbar fixed="bottom">
      <b-col>
        <router-link to="/">
          <b-button block variant="secondary" size="lg">
            <b-icon-house></b-icon-house>
          </b-button>
        </router-link>
      </b-col>
    </b-navbar>
  </div>
</template>

<script>
import { StreamBarcodeReader } from 'vue-barcode-reader';

export default {
  name: 'Scanner',
  data() {
    return {
    };
  },
  components: {
    StreamBarcodeReader,
  },
  methods: {
    onDecode(result) {
      this.$router.push({ name: 'quantity', params: { sku: result } });
    },
    onLoaded() {
    },
  },
};
</script>

<style>
.scanner-container {
  margin-top: 0.6rem;
}
</style>
